module.exports = __webpack_public_path__ + "src/app/_content/MOTFonts/BMWMotorradW01-Light.woff?734246b6804ac647127f49a12902f973";